import {
    KNOWLEDGE_ITEM_RESPONSE,
    KNOWLEDGE_ITEM_SAVE_RESPONSE,
    MODERATION_FEED_ITEM_RESPONSE,
    MODERATION_FEED_ITEM_SAVE_RESPONSE,
    COMMUNITY_ITEM_RESPONSE,
    DIMENSION_ITEM_RESPONSE,
    STUDIO_EDIT_ADD_KEY_ISSUES_RESPONSE,
    STUDIO_ITEM_RESPONSE,
    TOPIC_LIST_RESPONSE,
    TOPIC_ITEM_RESPONSE,
    TOPIC_ITEM_SAVE_RESPONSE,
    SOURCE_ITEM_RESPONSE,
    UNAUTHENTICATED,
    CLUSTER_ITEM_RESPONSE
} from "../../actions/action-types"
import { extractEntitiesFromData } from "./entity-reducer-utils"
import { normalise } from "../../models/entities/topic"

export default (state = {}, action) => {
    const { type, data, receivedAt } = action
    switch (type) {
        case STUDIO_ITEM_RESPONSE:
            return (data.dimensions || []).reduce(
                (newState, dimension) =>
                    extractEntitiesFromData(dimension.topics, newState),
                state
            )
        case DIMENSION_ITEM_RESPONSE:
            return extractEntitiesFromData(
                (data.topics || []).concat(data.primary_topics || []),
                state
            )
        case STUDIO_EDIT_ADD_KEY_ISSUES_RESPONSE:
            const topics = action.dimensionActions.reduce(
                (topics, { data }) =>
                    topics
                        .concat(data.topics || [])
                        .concat(data.primary_topics || []),
                []
            )
            return extractEntitiesFromData(topics, state)
        case KNOWLEDGE_ITEM_SAVE_RESPONSE:
        case KNOWLEDGE_ITEM_RESPONSE:
        case MODERATION_FEED_ITEM_RESPONSE:
        case MODERATION_FEED_ITEM_SAVE_RESPONSE:
        case COMMUNITY_ITEM_RESPONSE:
        case SOURCE_ITEM_RESPONSE:
        case CLUSTER_ITEM_RESPONSE:
            return extractEntitiesFromData(data.topics, state)
        case TOPIC_LIST_RESPONSE:
            return extractEntitiesFromData(data, state)
        case TOPIC_ITEM_SAVE_RESPONSE:
        case TOPIC_ITEM_RESPONSE:
            return {
                ...state,
                [data.id]: {
                    ...state[data.id],
                    ...normalise(data),
                    lastUpdatedAt: receivedAt
                }
            }
        case UNAUTHENTICATED:
            return {}
        default:
            return state
    }
}
